import React, { useState } from "react";

import Button from "@material-ui/core/Button";
import CssBaseline from "@material-ui/core/CssBaseline";
import TextField from "@material-ui/core/TextField";
import Typography from "@material-ui/core/Typography";
import { makeStyles } from "@material-ui/core/styles";
import Container from "@material-ui/core/Container";
import { Card } from "@material-ui/core";
import Loader from "../../../../utilityComponents/Loader";
const useStyles = makeStyles((theme) => ({
  paper: {
    marginTop: theme.spacing(2),
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  form: {
    width: "100%", // Fix IE 11 issue.
    marginTop: theme.spacing(1),
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
  },
}));

const UserCard = (props) => {
  const [username, setUsername] = useState(null);
  const [password, setPassword] = useState(null);
  const classes = useStyles();
  const onSubmit = async (event) => {
    event.preventDefault();
    if (!username) setUsername("");

    if (!password) setPassword("");

    if (username && password)
      props.loginUser(
        props.initalLoader,
        {
          username,
          password,
        },
        "/welcome"
      );
  };
  return props.loader ? (
    <Loader />
  ) : (
    <Card
      raised={true}
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "space-evenly",
        minHeight: "380px",
        maxWidth: "400px",
        borderRadius: "10px",
      }}
    >
      <Container component="main" maxWidth="xs">
        <CssBaseline />
        <div className={classes.paper}>
          <div style={{ width: "100%" }}>
            <Typography
              component="h1"
              variant="h5"
              style={{ fontWeight: "600" }}
            >
              Sign in
            </Typography>
            <Typography variant="caption" gutterBottom>
              Welcome! Please login to your account
            </Typography>
          </div>
          <form onSubmit={onSubmit}>
            <TextField
              error={username == null ? false : username == "" ? true : false}
              helperText={
                username == null || username != "" ? " " : "Username Required*"
              }
              variant="outlined"
              margin="normal"
              fullWidth
              id="username"
              inputProps={{ spellCheck: 'false' }}
              label="Username"
              value={username || ""}
              onChange={(e) => setUsername(e.target.value)}
            />
            <TextField
              error={password == null ? false : password == "" ? true : false}
              helperText={
                password == null || password != "" ? " " : "Password Required*"
              }
              variant="outlined"
              margin="normal"
              fullWidth
              label="Password"
              type="password"
              id="password"
              value={password ||""}
              onChange={(e) => setPassword(e.target.value)}
            />
            <Button
              type="submit"
              fullWidth
              variant="contained"
              color="primary"
              className={classes.submit}
            >
              Sign In
            </Button>
          </form>
        </div>
      </Container>

      <div className="row" style={{ paddingTop: "5%", paddingBottom: "5%" }}>
        <div className="col-12">
          <div style={{ textAlign: "center", fontWeight: "bold" }}>
            Powered by{" "}
            <a
              target="_blank"
              rel="noopener noreferrer"
              href="https://www.kpit.com/"
            >
              KPIT
            </a>
          </div>
        </div>
      </div>
    </Card>
  );
};

export default UserCard;
